import { CashDrawerState } from '../../interfaces/states/CashDrawerState';
import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';

const initialState: CashDrawerState = {
  open: false,
  limitExceeded: false,
};

class CashDrawerReducer extends ImmerReducer<CashDrawerState> {
  public setCashDrawerState(open: boolean): void {
    this.draftState = { ...this.draftState, open };
  }

  public resetState(): void {
    this.draftState = initialState;
  }

  public setDrawerLimitExceeded(limitExceeded: boolean): void {
    this.draftState = { ...this.draftState, limitExceeded };
  }
}

export const CashDrawerActions = createActionCreators(CashDrawerReducer);
export const CashDrawerReducerFunction = createReducerFunction(CashDrawerReducer, initialState);
